export const MODAL_STATE = {
  INSERT: 1,
  UPDATE: 2,
};
export const DEFAULT_CHAIN_STORE_MODAL_STATE = {
  open: false,
  mode: MODAL_STATE.INSERT,
  isAlien: false,
};
